<app-pan-card header="Transactions" [isPageContainer]="true" pageContainerSize="xl">
  <app-page-filters
    [allowLocationSelection]="true"
    [locationSelectionAutoSelectLocationIds]="[locationId()]"
    [(selectedLocations)]="selectedLocation"
    (selectedLocationsChange)="updateLocationData()"
  >
  </app-page-filters>
</app-pan-card>

@if (selectedLocation(); as location) {
  <app-pan-card class="mt-3" [header]="location.name" [subheader]="location.branch_name" [isPageContainer]="true" pageContainerSize="xl">
    <app-sold-details [locationId]="location.id"></app-sold-details>
  </app-pan-card>
}

<div class="h-[96px]"></div>
